"use client";

import React from "react";
import { V3Topbar } from "@/components/landing/V3Topbar";
import Footer from "@/components/common/Footer";
import { v3 } from "@/lib/theme";

import { V3Hero, V3TaglineBand } from "@/components/landing/V3Hero";
import { V3SectionOverview } from "@/components/landing/V3SectionOverview";
import { V3SectionCalculator } from "@/components/landing/V3SectionCalculator";
import { V3SectionMarktwert } from "@/components/landing/V3SectionMarktwert";
import { V3SectionHouseScroll } from "@/components/landing/V3SectionHouseScroll";
import { V3SectionExcel } from "@/components/landing/V3SectionExcel";
import { V3SectionZinsen } from "@/components/landing/V3SectionZinsen";
import { V3SectionBank } from "@/components/landing/V3SectionBank";
import { V3SectionTestimonials } from "@/components/landing/V3SectionTestimonials";
import { V3SectionPricing } from "@/components/landing/V3SectionPricing";

export default function HomePage() {
  return (
    <div className="bg-background text-foreground min-h-screen" style={{ fontFamily: v3.sans }}>
      <V3Topbar />
      
      <main>
        <V3Hero />
        <V3SectionOverview />
        <V3SectionCalculator />
        <V3SectionMarktwert />
        <V3SectionHouseScroll />
        <V3SectionExcel />
        <V3SectionZinsen />
        <V3SectionBank />
        <V3TaglineBand />
        <V3SectionTestimonials />
        <V3SectionPricing />
      </main>

      <Footer />
    </div>
  );
}
